import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'

import { Observable } from 'rxjs'

import { RequestWrap } from '../../../app/core/models/request-wrap'
import { OrderHistory } from '../models/orderhistory'

import { environment } from './../../../environments/environment'
import { handleEmpty } from '../../core/helpers/rx-pipes';
import { OrderHistoryLine } from '../models/orderhistoryline';

const orderHeadersUrl = '/orderheaders'
const orderLinesUrl = '/orderlines'

@Injectable()
export class OrderHistoryService {
  constructor (
    private http: HttpClient
  ) { }

  public getOrderHeaders (customerId: string, userId?: string, pagenr: number = 1, limit: number = 15): Observable<RequestWrap<OrderHistory[]>> {
    let params = new HttpParams()

    params = params.set('customerId', customerId)

    if (userId) {
      params.set('userId', userId)
    }

    params = params.set('pagenr', pagenr.toString())
    params = params.set('limit', limit.toString())

    // Filter on status "exported". We only want finished orders for now
    params = params.set('status', 'exported')

    return this.http.get<RequestWrap<OrderHistory[]>>(
      `${environment.baseApiUrl}${orderHeadersUrl}`, {
        observe: 'response',
        params: params
      }
    ).pipe(handleEmpty())
  }

  public getOrderHeader (customerId: string, ordernumber: number): Observable<OrderHistory> {
    let params = new HttpParams()

    params = params.set('customerId', customerId)

    return this.http.get<OrderHistory>(
      `${environment.baseApiUrl}${orderHeadersUrl}/${ordernumber.toString()}`, {
        params: params
      }
    )
  }

  public getOrderLines (customerId: string, ordernumber: number, pagenr: number = 1, limit: number = 15): Observable<RequestWrap<OrderHistoryLine[]>> {
    let params = new HttpParams()

    params = params.set('customerId', customerId)
    params = params.set('ordernumber', ordernumber.toString())
    params = params.set('pagenr', pagenr.toString())
    params = params.set('limit', limit.toString())

    return this.http.get<RequestWrap<OrderHistoryLine[]>>(
      `${environment.baseApiUrl}${orderLinesUrl}`, {
        observe: 'response',
        params: params
      }
    ).pipe(handleEmpty())
  }
}
